import { useCloseRequestMemo } from '@hooks/Services';
import { Error, Loading } from '@organisms/Feedbacks';
import React, { useEffect } from 'react';
import styled from 'styled-components';

type Props = {
    formData: FormData;
    onSubmitComplete: any;
};
type FormData = {
    swCloseRequestId: any;
    memoContent: string;
    createUser: string;
    timestamp: number;
};

const SubmitFormClose = (props: Props) => {
    const { formData, onSubmitComplete } = props;
    const { error, loading } = useCloseRequestMemo.usePostData(formData);
    useEffect(() => {
        (!loading && !error && (onSubmitComplete()));
    });
    return (
        <FormWithStyled>
            {loading && <Loading />}
            {error && <Error />}
        </FormWithStyled>
    );
};

const FormWithStyled = styled.form`
    margin: 5px 0 0;
`

export default SubmitFormClose;